import { render, staticRenderFns } from "./MyInstituteView.vue?vue&type=template&id=5abca7b8&"
import script from "./MyInstituteView.vue?vue&type=script&lang=js&"
export * from "./MyInstituteView.vue?vue&type=script&lang=js&"
import style0 from "./MyInstituteView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports